<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">Lotações</v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <WorkstationList />
    </v-card-text>
  </v-card>
</template>

<script>
import WorkstationList from './components/WorkstationList.vue'
export default {
  name: 'WorkstationsAdmin',
  components: {
    WorkstationList,
  },
  data: function () {
    return {
      dialog: false,
    }
  },
  computed: {},
  methods: {},
}
</script>
